import { BridgeActionsBase, BridgeBase, CalibrationMode, RingCalibrationData, RingModel, RingTypeEnum, ViewType } from '@ortho-next/nextray-core';
import { Context } from './Context';

export interface BridgeActions extends BridgeActionsBase {
	/**
	 * Sets the line as calibration tools during calibration workflow.
	 */
	calibByLine: null;
	/**
	 * Sets the circle as calibration tools during calibration workflow.
	 */
	calibByCircle: null;
	/**
	 * Sets the ellipse as calibration tools during calibration workflow.
	 */
	calibByEllipse: null;
	/**
	 * Ends calibration workflow.
	 */
	calibrate: number;
	/**
	 * Starts calibration workflow.
	 */
	startCalibration: null;
	/**
	 * Resets calibration workflow.
	 */
	resetCalibration: null;
	/**
	 * Set circle calibration points.
	 */
	setCalibrationCircleFromPoints: { x: number, y: number }[];
	/**
	 * Set ring.
	 */
	setRing: { ringModel: RingModel, oppositeRingType: RingTypeEnum };
	/**
	 * Set ring calibration data (patient garage only).
	 */
	setRingCalibrationData: RingCalibrationData;
	/**
	 * Resets all image tools.
	 */
	resetImageTools: null;
}

/**
 * Manages the communications between three.js and angular part.
 */
export class Bridge extends BridgeBase {
	protected declare _context: Context; // TODO put it in the package as generic

	public override mapEvent<K extends keyof BridgeActions>(type: K, args: BridgeActions[K]): void {
		switch (type) {
			case "calibByLine":
				return this._context.handle("setCalibrationMode", CalibrationMode.line);
			case "calibByCircle":
				return this._context.handle("setCalibrationMode", CalibrationMode.circle);
			case "calibByEllipse":
				return this._context.handle("setCalibrationMode", CalibrationMode.ellipse);
			case "calibrate":
				return this._context.handle("calibrate", args as number);
			case "startCalibration":
				return this._context.handle("startCalibration", ViewType.AP);
			case "resetCalibration":
				return this._context.handle("resetCalibration", ViewType.AP);
			case "setRing":
				return this._context.handle("setRing", args as { ringModel: RingModel, oppositeRingType: RingTypeEnum });
			case "setRingCalibrationData":
				return this._context.handle("setRingCalibrationData", args as RingCalibrationData);
			case "setCalibrationCircleFromPoints":
				return this._context.handle("setCalibrationCircleFromPoints", args as { x: number, y: number }[]);
			case "resetImageTools":
				return this._context.handle("resetImageTools", null);
		}

		return super.mapEvent(type, args as any); // TODO fix this any cast
	}
}
